export const CALCULATIONS_PAGE = {
    'CALCULATIONS.PAGE.TITLE': 'Calcule',
    'CALCULATIONS.NEW_CALCULATION.PAGE.TITLE': 'Calcul nou',
    'CALCULATIONS.NEW_CALCULATION.MODAL.TITLE': 'Calcul nou',
    'CALCULATION.BALANCE.ACCEPTED_EXTENSIONS': 'Extensie acceptată: xls, xlsx',
    'CALCULATION.RECEIPT.ACCEPTED_EXTENSION': 'Extensie acceptată: pdf'
};
